import { UAParser } from "ua-parser-js"

export default function useIsMobileAgent() {
  const uaParser = new UAParser()
  return uaParser.getDevice().type === "mobile"
}
